/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateHookRequest
 */
export interface CreateHookRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateHookRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHookRequest
     */
    externalServiceId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateHookRequest
     */
    events?: Array<string>;
}

/**
 * Check if a given object implements the CreateHookRequest interface.
 */
export function instanceOfCreateHookRequest(value: object): boolean {
    return true;
}

export function CreateHookRequestFromJSON(json: any): CreateHookRequest {
    return CreateHookRequestFromJSONTyped(json, false);
}

export function CreateHookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'externalServiceId': json['externalServiceId'] == null ? undefined : json['externalServiceId'],
        'events': json['events'] == null ? undefined : json['events'],
    };
}

export function CreateHookRequestToJSON(value?: CreateHookRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'externalServiceId': value['externalServiceId'],
        'events': value['events'],
    };
}

